import {Component, computed, input, model, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MultiSelectModule} from 'primeng/multiselect';
import {InputTextModule} from 'primeng/inputtext';
import {TranslocoPipe} from '@jsverse/transloco';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {DirectusTranslatedItem} from '@frontend/directus';
import {DirectusTooltipComponent} from '../../../directus-tooltip/directus-tooltip.component';
import {MultiSelectionLabelComponent} from '../../form-field/form-field-multiselect/multi-selection-label/multi-selection-label.component';

@Component({
  selector: 'app-model-field-multiselect',
  imports: [
    CommonModule,
    FormsModule,
    MultiSelectModule,
    InputTextModule,
    TranslocoPipe,
    TranslateDirectusPipe,
    DirectusTooltipComponent,
    MultiSelectionLabelComponent,
  ],
  templateUrl: './model-field-multiselect.component.html',
})
export class ModelFieldMultiselectComponent {
  id = input.required<string>();
  label = input.required<string>();
  noSelectKey = input<string>('multiselect.noSelect.item');
  showSelectionLabel = input<boolean>(true);
  tooltipKey = input<string>('');
  placeholder = input<string>('common.select');
  selectTranslatedOptions = input<DirectusTranslatedItem[]>([]);
  isReadOnly = input<boolean>(false);
  isRequired = input<boolean>(false);
  invalid = input<boolean>(false);
  smallLabel = input<boolean>(false);
  showCountryFlags = input<boolean>(false);
  showClear = input<boolean>(false);

  value = model<any[]>([]);

  protected readonly isTouched = signal<boolean>(false);

  protected readonly showInvalid = computed<boolean>(
    () =>
      this.isTouched() && (this.invalid() || (this.isRequired() && !(this.value()?.length > 0))),
  );

  protected readonly selectedIds = computed<Array<string | number>>(() => this.value() ?? []);

  readonly hasFilterText = computed(() => {
    const options = this.selectTranslatedOptions();
    return !!options?.[0]?.filterText;
  });

  protected onValueChange(values: any[] | null): void {
    this.value.set(values ?? []);
  }

  protected markAsTouched(): void {
    this.isTouched.set(true);
  }

  protected removeSelection(removedId: string | number): void {
    this.value.update((values) => (values ?? []).filter((id) => id !== removedId));
  }
}
